<template>

  <div id="memo" v-show="canMemoUse">
    <button class="memo-btn" :class="[ isMemoShow ? 'is-show' : '']"  @click="memoOpen"><img src="@/assets/img/memo/icon-memo.svg" alt="">メモ</button>

    <div class="memo" :id="this.showId" :class="[ hasAttachment ? 'has-attachment' : '', isShow ? 'is-show' : '', noFooter ? 'no-footer' : '' ]">

      <!-- メモ一覧　ヘッダー部 -->
      <div class="memo-header" id="memoListHeader">
        <p class="memo-title">メモ一覧</p>
        <div class="memo-header__contents">
          <button class="memo-header__btn is-primary js-memo-new" @click.prevent="newOpen"><img src="@/assets/img/memo/icon-add.svg" alt="">新規作成</button>
        </div>
          <button class="memo-header__close-btn js-memo-hide" @click="memoClose"><img src="@/assets/img/memo/icon-close.svg" alt=""></button>
      </div>
      <!-- メモ一覧　ボディ部 -->
      <div class="memo-body" id="memoListBody">

        <div v-if="hasNoMemo">
          <div class="memo-blank">
            <ul class="memo-blank-list">
              <li>議事録や備忘録に使えるメモを作成することができます。</li>
              <li v-if="isAdmin">メモは顧問先ごとに作成できます。</li>
              <li v-if="isAdmin">作成したメモは顧問先に共有することもできます。</li>
              <li v-if="isAdmin">作成したメモはカルテ（トップページ）に表示することができます。</li>
              <li v-if="!isAdmin">作成したメモは社労士からは見えません。</li>
              <li v-if="!isAdmin">社労士が作成したメモが共有されることがあります。</li>
            </ul>
            <button class="memo-body__btn is-primary js-memo-new" @click.prevent="newOpen"><img src="@/assets/img/memo/icon-add.svg" alt="">メモを新規作成</button>
          </div>
        </div>

        <div v-if="!hasNoMemo">
          <ul class="memo-list" v-if="!hasNoMemo">
            <li class="memo-list__item" v-for="(memo,key) in memoList" :key="key" >
              <a class="memo-list__link" href="#memoDetail" @click.prevent="detailOpen(memo.memoId)">
                <span class="memo-list__icon"><img src="@/assets/img/memo/icon-attachment-gray.svg" alt="添付ファイル" v-if="memo.attachments.length>0"></span>
                <span class="memo-list__title">
                  <span class="memo-list__title-text">{{ memo.title | omittedTitle }}</span>
                  <span class="memo-list__title-label" v-show="memo.shareFlg">共有中</span>
                </span>
                <span class="memo-list__name">{{ memo.currentNm | omittedUserName }}</span>
                <span class="memo-list__date">{{$dayjs(memo.currentTs).format("YY/MM/DD")}}</span>
              </a>
            </li>
          </ul>
        </div>

      </div>
      <!-- メモ一覧　フッター部 -->
      <div class="memo-footer" id="memoListFooter">
        <div class="memo-footer__inner">
          <div class="memo-footer__info">
            <p>メモ件数：{{memoCount}}/{{maxMemoCount}}</p>
<!--            <p>添付：{{totalFileSize}}/{{maxTotalFileSize}}MB</p>-->
          </div>
          <div class="memo-footer__delete">
            <a href="#memoDeleteList" class="link-arrow js-memo-history" @click="histOpen">削除履歴</a>
          </div>
        </div>
      </div>

      <!-- メモ詳細　ヘッダー部 -->
      <div class="memo-header" id="memoDetailHeader">
        <p class='memo-title'>{{selectedMemo.title}}</p>
        <div class="memo-header__contents">
          <button class="memo-header__btn is-primary js-memo-edit" @click="memoEdit(selectedMemo.memoId)"><img src="@/assets/img/memo/icon-edit.svg" alt="">編集</button>
          <button class="memo-header__link is-delete" @click.prevent="memoDelete" v-show="isShared==false">削除</button>
          <button class="memo-header__listlink js-memo-list" @click.prevent="listOpen">メモ一覧</button>
        </div>
        <button class="memo-header__close-btn js-memo-hide" @click="memoClose"><img src="@/assets/img/memo/icon-close.svg" alt=""></button>
      </div>
      <!-- メモ詳細　ボディ部 -->
      <div class="memo-body" id="memoDetailBody">
        <p id="memoDetailBodyContent" class="l-text-memo" style="white-space: pre-line;" v-html="repalceLink(selectedMemo.body)"></p>
      </div>
      <!-- メモ詳細　フッター部 -->
      <div class="memo-footer" id="memoDetailFooter">
        <div class="memo-footer__inner">
          <div class="memo-footer__attachment" v-if="selectedMemo.attachments.length > 0">
            <div class="memo-footer__attachment-link" v-for="(attachment,key) in selectedMemo.attachments" :key="key"><a href="">{{attachment.name|omittedFileName}}</a></div>
          </div>
          <div class="memo-footer__info">
            <span class="memo-list__title-label is-given" v-show="selectedMemo.shareFlg">共有中</span>
            <span class="memo-list__title-label is-home" v-if="selectedMemo.showFlg">カルテに表示中</span>
          </div>
        </div>
      </div>

      <!-- メモ編集　ヘッダー部 -->
      <div class="memo-header" id="memoEditHeader">
        <p class="memo-title">メモの編集</p>
        <button class="memo-header__close-btn js-memo-hide" @click="memoClose"><img src="@/assets/img/memo/icon-close.svg" alt=""></button>
      </div>
      <!-- メモ編集　ボディ部 -->
      <div class="memo-body" id="memoEditBody">
        <div class="l-memo-contentsSection error" v-if="errorMessage">
          <div style="padding-bottom:0px;">
            <span style="color:red; font-size: 1.5rem;">{{errorMessage}}</span>
          </div>
        </div>
        <input type="text" class="memo-edit-title" placeholder="メモ名称" v-model="selectedMemo.title">
        <textarea class="memo-edit-body" placeholder="本文" v-model="selectedMemo.body"></textarea>
      </div>
      <!-- メモ編集　フッター部 -->
      <div class="memo-footer" id="memoEditFooter">
        <div class="memo-footer__inner">
<!--          <div class="memo-footer__attachment">
            <button class="memo-footer__btn is-lg js-attachment-show" @click="attachmentOpen(selectedMemo.memoId)"><img src="@/assets/img/memo/icon-attachment.svg" alt="">添付</button>
            <div class="memo-footer__attachment-link" v-for="(attachment, index) in selectedMemo.attachments" :key="index" :class="$data['deleted_' + index] ? 'is-delete' : ''">
              <span>{{attachment.name | omittedFileName}}</span>
              <button class="js-attachment-delete" @click="attachmentDelete(index,attachment.attachmentId)"><img src="@/assets/img/memo/icon-delete-s.svg" alt=""></button>
            </div>
          </div>
-->
          <div class="memo-footer__editgroup">
            <div class="memo-footer__info">
              <label class="l-checkbox" v-show="loginUserType==1">
                <input type="checkbox" v-model="selectedMemo.shareFlg" :value="selectedMemo.shareFlg" :checked="selectedMemo.shareFlg" @change="shareChange(selectedMemo)" />共有
              </label>
              <label class="l-checkbox" v-show="loginUserType==1">
                <input type="checkbox" v-model="selectedMemo.showFlg" :value="selectedMemo.showFlg" :checked="selectedMemo.showFlg" @change="showChange(selectedMemo)"/>カルテに表示する
              </label>
            </div>
            <div class="menu-footer__btngroup">
              <button class="memo-footer__btn is-primary" @click="memoUpdate()"><img src="@/assets/img/memo/icon-save-white.svg" alt="">保存</button>
              <button class="memo-footer__btn js-memo-edit-cancel" @click="editCancel">キャンセル</button>
            </div>
          </div>
        </div>
      </div>

      <!-- メモ新規登録　ヘッダー部 -->
      <div class="memo-header" id="memoNewHeader">
        <p class="memo-title">メモの新規作成</p>
        <button class="memo-header__close-btn js-memo-hide" @click="memoClose"><img src="@/assets/img/memo/icon-close.svg" alt=""></button>
      </div>
      <!-- メモ新規登録　ボディ部 -->
      <div class="memo-body" id="memoNewBody">
        <div class="l-memo-contentsSection error" v-if="errorMessage">
          <div style="padding-bottom:0px;">
            <span style="color:red; font-size: 1.5rem;">{{errorMessage}}</span>
          </div>
        </div>
        <input type="text" class="memo-edit-title" placeholder="メモ名称" v-model="selectedMemo.title">
        <textarea class="memo-edit-body" placeholder="本文" v-model="selectedMemo.body"></textarea>
      </div>
      <!-- メモ新規登録　フッター部 -->
      <div class="memo-footer" id="memoNewFooter">
        <div class="memo-footer__inner">
<!--          <div class="memo-footer__attachment">
            <button class="memo-footer__btn is-lg js-attachment-show" @click="attachmentOpen(selectedMemo.memoId)"><img src="@/assets/img/memo/icon-attachment.svg" alt="">添付</button>
            <div class="memo-footer__attachment-link" v-for="(attachment,index) in selectedMemo.attachments" :key="index" :class="$data['deleted_' + index] ? 'is-delete' : ''">
              <span>{{attachment.name | omittedFileName}}</span>
              <button class="js-attachment-delete" @click="attachmentDelete(index,attachment.attachmentId)"><img src="@/assets/img/memo/icon-delete-s.svg" alt=""></button>
            </div>
          </div>
-->
          <div class="memo-footer__editgroup">
            <div class="memo-footer__info">
              <label class="l-checkbox" v-show="loginUserType==1">
                <input type="checkbox" v-model="selectedMemo.shareFlg" :value="selectedMemo.shareFlg" :checked="selectedMemo.shareFlg" @change="shareChange(selectedMemo)" />共有
              </label>
              <label class="l-checkbox" v-show="loginUserType==1">
                <input type="checkbox" v-model="selectedMemo.showFlg" :value="selectedMemo.showFlg" :checked="selectedMemo.showFlg" @change="showChange(selectedMemo)"/>カルテに表示する
              </label>
            </div>
            <div class="menu-footer__btngroup">
              <button class="memo-footer__btn is-primary" @click="newSave"><img src="@/assets/img/memo/icon-save-white.svg" alt="">保存</button>
              <button class="memo-footer__btn js-memo-new-cancel" @click="newCancel">キャンセル</button>
            </div>
          </div>
        </div>
      </div>

      <!-- 添付ファイル登録 -->
      <div class="memo-attachment" :class="[isAttachmentShow ? 'is-show' : '']">
        <button class="memo-modal-close js-attachment-cancel"><img src="@/assets/img/memo/icon-cross.svg" alt=""></button>
        <div class="memo-attachment__inner">
          <p class="memo-attachment__title">ファイル添付</p>
          <div class="memo-attachment__error" v-show="errorMessages.length > 0">
            <ul>
              <li v-for="(error,key) in errorMessages" :key="key">{{error}}</li>
            </ul>
          </div>
          <div class="memo-attachment__input">
            <input type="file" id="attachment" ref="attachment" @change="validateFile">
            <button class="memo-attachment__submit-btn" @click="setFiles">決定</button>
            <button class="memo-attachment__cancel-btn js-attachment-cancel" @click="attachmentClose">キャンセル</button>
          </div>
          <div class="memo-attachment__note">
            <ul>
              <li>添付可能なファイル形式は以下のとおりです。<br>pdf, txt, rtf, jpeg, jpg, png, gif, xls/xlsx, doc/docx, csv</li>
              <li>以下の文字をファイル名に含むファイルは添付できません<br>円記号, スラッシュ, コロン, アスタリスク, クエスチョンマーク, ダブルクォーテーション, 不等号, バーティカルバー</li>
              <li>添付可能なファイルのサイズは１サイズあたり10Mまでです</li>
              <li>１つのメモにつき３つまでファイルを添付することができます。</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- 削除履歴 -->
      <div class="memo-history" :class="[histIsShow ? 'is-show' : '']">
        <button class="memo-modal-close js-memo-history-cancel" @click="histClose"><img src="@/assets/img/memo/icon-cross.svg" alt=""></button>
        <div class="memo-history__inner">
          <p class="memo-history__title">削除履歴</p>
          <ul class="memo-history-list">
            <li class="memo-history-list__header">
              <span class="memo-history-list__title">メモ・ファイル名</span>
              <span class="memo-history-list__name">削除したユーザー</span>
              <span class="memo-history-list__date">削除日</span>
            </li>
            <li class="memo-history-list__item" v-for="(file,key) in deleteFileList" :key="key">
              <span class="memo-history-list__title">{{ file.name | omittedTitle}}</span>
              <span class="memo-history-list__name">{{ file.nm | omittedUserName }}</span>
              <span class="memo-history-list__date">{{$dayjs(file.deleteTs).format("YY/MM/DD")}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="https://code.jquery.com/jquery-3.5.1.min.js "></script>
<script src="https://code.jquery.com/ui/1.12.1/jquery-ui.js"></script>

<script>

export default {
  name: 'Memo',
  components: {
  },
  mounted() {
    jQuery(function ($) {
      function stopDragging() {
        $('.human-capital-page').off('mousemove.memoHeader mouseup.memoHeader mouseleave.memoHeader');
      }
      $(".memo").resizable({
          handles: "n",
          minHeight: 340,
          maxHeight: $(window).height() * 0.9
      });

      $(".memo-header").on("mousedown", function(event) {
          let $memo = $(this).closest(".memo");
          let startY = event.clientY;
          let isDragging = false;

          $(".human-capital-page").on("mousemove.memoHeader", function(e) {
              let deltaY = Math.abs(e.clientY - startY);

              if (deltaY > 4) { // ドラッグと判定する閾値
                  isDragging = true;
              }

              if (isDragging) {
                  let newHeight = $(window).height() - e.clientY - 10; // 10pxはrightからのマージン分
                  let maxHeight = $(window).height() * 0.9;

                  if (newHeight >= 200 && newHeight <= maxHeight) {
                      $memo.height(newHeight);
                  }
              }
          }).on("mouseup.memoHeader mouseleave.memoHeader", function() {
              stopDragging();
          });
          event.preventDefault();
      });
    })
  },
    filters: {
    // ３点表示Filter ユーザー名
    omittedUserName(text) {
      if ( text === null ) return '';
      return text.length > 5 ? text.slice(0, 5) + "…" : text;
    },
    // ３点表示Filter ファイル名
    omittedFileName(text) {
      if ( text === null ) return '';
      return text.length > 9 ? text.slice(0, 9) + "…" : text;
    },
    // ３点表示Filter メモ名称
    omittedTitle(text) {
      if ( text === null ) return '';
      return text.length > 22 ? text.slice(0, 22) + "…" : text;
    }
  },
  data() {
    return {
      hasError: false,
      errorMessage:"",
      errorMessages:[],

      deleted_0: false,
      deleted_1: false,
      deleted_2: false,

      showId: "memoList",
      hasAttachment: false,
      noFooter: false,
      isShow: false,
      histIsShow: false,
      isAttachmentShow: false,

      isAdmin: false,
      isAllPermission: false,
      isSystemAdmin: false,
      isSupple: false,
      managedCorpId: null,
      currentCorpId: null,

      loginUserType: 0,     // ユーザータイプ 0:一般 1:専門家
      memoList: [],         // メモリスト情報
      deleteFileList: [],   // 削除ファイルリスト情報
      memoCount: 0,         // メモ件数
      maxMemoCount: 10,     // メモ登録上限値
      totalFileSize: 0,     // 総添付ファイルサイズ
      maxTotalFileSize: 300,// 総添付ファイルサイズ上限値

      selectedMemo: {
        attachments: [],
        title: "",
        body: "",
        showFlg: false,
        shareFlg: false,
        corpId: null,
        managedCorpId: null,
        deleteFlg: false,
      },
      showMemo: {},

      isList: true,
      isNew: false,
      isDetail: false,
      showHistory: false,

      isMemoShow: true,
    }
  },
  created: async function() {
    // 表示されるURLのメモ使用設定がtrueの時のみ実行
    if (this.$route.meta.isUseMemo) {
      // 認証情報の取得
      const authority = await this.$store.dispatch('auth/getAuthority');
      this.isAdmin = authority.isAdmin;
      this.isAllPermission = authority.isAllPermission;
      this.isSystemAdmin = authority.isSystemAdmin;
      this.isSupple = authority.isSupple;
      this.managedCorpId = authority.corpId; // ログインユーザーのcorpId
      // メモ情報の取得
      await this.getData(this.corpId, this.managedCorpId)
    }

  },
  computed: {
    isProcessing() {
      return this.$store.getters['alert/isProcessing'];
    },
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    user() {
      return this.$store.getters['auth/getUser'];
    },
    // 一般ユーザーからみたメモが共有であるかどうかのフラグ
    isShared() {
      return ( this.loginUserType==0 && ( this.selectedMemo.corpId != this.selectedMemo.managedCorpId ) );
    },
    // メモ表示設定値で管理。つけくわえてシステム管理画面、労務サプリユーザーについては使用できない。
    canMemoUse() {
      /**
       * システム管理画面については通常画面と同じURLで管理している画面があるので、
       * メモ表示設定値だけでなく、ログイン時のユーザー情報でシステム管理画面へのログインかどうかをチェックしている
       * システム管理画面ログイン時は、isSystemAdmin項目が設定されていないので、isSystemAdmin == nullで判断する
       * 労務サプリユーザーについてはisSupple値で判断する
       */
      return this.$route.meta.isUseMemo && !(this.isSystemAdmin == null) && !this.isSupple
    },
    memoOpenFlag() {
      return this.$store.getters['diag/getMemoOpenFlag'];
    },
    hasNoMemo() {
      return this.memoList.length == 0;
    },
    isAdminUser() {
      return ( this.managedCorpId != this.corpId );
    }
  },

 watch: {
   /**
    * カルテ画面のメモ編集ボタンがクリックされたときの処理
    */
    async memoOpenFlag(value) {

      // メモタブが閉じているときは開く
      if ( this.isMemoShow ) this.memoOpen();

      // 添付ファイル設定画面が開かれているときは閉じる
      if ( this.isAttachmentShow ) this.isAttachmentShow = false;
      
      // 削除履歴画面が開かれているときは閉じる
      if ( this.histIsShow ) this.histIsShow = false;

      // カルテ表示対象のメモIDを抽出
      if ( this.showMemo != null ) this.memoEdit(this.showMemo.memoId);

    },
    /**
     * 法人IDが変更されたときの処理
     */
    async corpId(value) {
      if ( value != null ){
        // 認証情報の取得
        const authority = await this.$store.dispatch('auth/getAuthority');
        this.isAdmin = authority.isAdmin;
        this.isAllPermission = authority.isAllPermission;
        this.isSystemAdmin = authority.isSystemAdmin;
        this.isSupple = authority.isSupple;
        this.managedCorpId = authority.corpId; // ログインユーザーのcorpId
        if ( this.currentCorpId != value ) this.reset();
        this.currentCorpId = value; // 選択されたcorpId
      }
    },
    /**
     * ログインしたときに呼び出される処理
     */
    async user(value) {
      this.isAdmin = value.isAdmin;
      this.isAllPermission = value.isAllPermission;
      this.isSystemAdmin = value.isSystemAdmin;
      this.isSupple = value.isSupple;
      // ログイン時に初期化しておく
      // ※ログアウト後、同じユーザーでログインしたときに、corpIdの変更イベントが実行されたときにメモのリセット処理が実行されなくなるため
      this.currentCorpId = null;
    }
  },

  methods: {
    /**
     * 状態をリセットする
     */
    async reset(){
      // メモタブを閉じる
      await this.memoClose();
      // 添付ファイル設定画面が開かれているときは閉じる
      if ( this.isAttachmentShow ) this.isAttachmentShow = false;
      // 削除履歴画面が開かれているときは閉じる
      if ( this.histIsShow ) this.histIsShow = false;
      // メモ情報の取得
      await this.getData(this.corpId, this.managedCorpId)
      // メモ一覧を表示
      this.listOpen();
    },
    /**
     * メモタブを開く
     */
    memoOpen(){
      this.isMemoShow = false;
      this.isShow = true;
    },
    memoClose(){
      this.isMemoShow = true;
      this.isShow = false;
    },
    /**
     * メモ情報取得処理
     */
    async getData(corpId, managedCorpId) {

      if (!this.isSystemAdmin && !this.isSupple) {
        let res = await this.$axios.post('/ld/api/memo/getData', {
          corpId: corpId,
          managedCorpId: managedCorpId,
        });
        if (res.status==200) {
          // ユーザータイプ 0:一般 1:専門家
          this.loginUserType = res.data.loginUserType;
          // メモリスト情報
          this.memoList = res.data.memoList;
          // 削除ファイルリスト情報
          this.deleteFileList = res.data.deleteFileList;
          // メモ件数
          this.memoCount = res.data.memoCount;
          this.maxMemoCount = res.data.maxMemoCount;
          // 添付ファイルサイズ
          this.totalFileSize = res.data.totalFileSize;
          this.maxTotalFileSize = res.data.maxTotalFileSize;
//          this.corpId = corpId;
          this.managedCorpId = managedCorpId;
          this.showMemo = res.data.showMemo;
          this.$store.dispatch('diag/setMemo', res.data.showMemo);

        }else{
          this.$toast.memo(res.data.message);
        }
      }
    },
    /**
     * メモ新規登録画面閉じる
     */
    async memoNewClose(memoId) {
      // listを開く
      this.getData(this.corpId, this.managedCorpId);
      this.isNew = false;
      if ( memoId == null ) {
        this.isList = true;
        this.isDetail = false;
      }else {
        this.isList = false;
        this.isDetail = true;
      }
    },
    /**
     * 添付ファイル選択画面　閉じる
     */
    async attachmentClose(){

      const file = document.getElementById('attachment').value;
      if ( file !== "" ) this.selectedMemo.attachments.pop();
      this.errorMessages = [];
      this.isAttachmentShow = false;
    },
    /**
     * 添付ファイルの削除
     */
    async attachmentDelete(index, attachmentId){
      if (confirm("添付ファイルを削除しますか？")) {
        if (attachmentId != undefined) {
          // こちらはupdate時
          if ( index == 0 ) this.deleted_0 = true;
          if ( index == 1 ) this.deleted_1 = true;
          if ( index == 2 ) this.deleted_2 = true;
          this.selectedMemo.attachments[index].deleteFlg = true;
        }else{
          // こちらはinsert時
          this.selectedMemo.attachments.splice(index,1);
        }
      }
    },
    /**
     * 添付ファイル選択画面　決定処理
     */
    setFiles() {
      document.getElementById('attachment').value = ''
      this.errorMessages = [];
      this.isAttachmentShow = false;
    },
    /**
     * 添付ファイル選択画面　開く
     */
    async attachmentOpen(memoId) {
      if ( memoId == null ) {
        if (this.selectedMemo.attachments.length == 3) {
          alert("アップロードできるファイル数が上限に達しています。\nこれ以上ファイルを添付することはできません。\n既存のファイルを削除してから再度お試しください。");
          return ;
        }
      }else {
        if (this.selectedMemo.attachments.length == 3) {
          alert("設定できるファイル数が上限に達しています。\nこれ以上ファイルを添付することはできません。\n既存のファイルを削除してから再度お試しください。");
          return ;
        }
      }
      this.errorMessages = [];
      document.getElementById('attachment').value = ''
      this.isAttachmentShow = true;
    },
    /**
     * 添付ファイルのチェック
     */
    validateFile: async function(event) {

      this.errorMessages = [];
      let file = event.target.files[0];

      this.selectedMemo.attachments.push({'memo_id': null, 'size': file.size, 'name': file.name, 'mime': file.type, 'data': file});
      let res = await this.$axios.post('/ld/api/memo/fileCheck', {'attachments':this.selectedMemo.attachments});
      if (res.status === 200) {
        // ここでnewとupdateでfilesの内容を入れる先が異なる
      }else{
        this.$toast.memo(res.data.message);
        this.errorMessages.push(res.data.message);
        if (this.errorMessages.length > 0) {
          //valueを空にしてリセットする
          document.getElementById('attachment').value = ''
          this.selectedMemo.attachments.pop();
        }
      }
    },
    async download(attachmentId){
      let res = await this.$axios.get('/ld/api/memo/attachmentDownload?attachmentId='+attachmentId);
    },
    /**
     * メモ更新処理
     */
    async memoUpdate() {
      // メモ情報を保存する
//      this.selectedMemo.corpId = this.corpId;
//      this.selectedMemo.managedCorpId = this.managedCorpId;
      let res = await this.$axios.post('/ld/api/memo/updateMemo', { memo: this.selectedMemo });
      if (res.status === 200) {
        var memoId = res.data.id;
        const formData = new FormData()
        var index = 0;
        this.selectedMemo.attachments.forEach(attachment => {
          formData.append('file['+ index + ']', attachment.data);
          formData.append('attachmentId['+ index + ']', attachment.attachmentId);
          formData.append('deleteFlg['+ index + ']', attachment.deleteFlg);
          index++;
        });
        formData.append('memoId', memoId);
        //config定義（headersを指定）
        const config = {headers:{ 'Content-Type' : 'multipart/form-data' }}
        let resFile = await this.$axios.post('/ld/api/memo/updateAttachment', formData, config);
        if ( resFile.status == 200 ){
          this.$toast.info('登録が完了しました');
          await this.getData(this.corpId, this.managedCorpId);
          this.deleted_0 = this.deleted_1 = this.deleted_2 = false;
          this.detailOpen(this.selectedMemo.memoId);
        }else if ( resFile.stats === 500 ){
          if (resFile.data.status === 501) {
            // エラーメッセージ表示（ファイル登録エラー）
            this.$toast.memo(resFile.data.message);
            this.getData(this.corpId, this.managedCorpId);
            this.deleted_0 = this.deleted_1 = this.deleted_2 = false;
            this.detailOpen(this.selectedMemo.memoId);
          }else if (resFile.data.status === 501) {
          }else{
            // エラーメッセージ表示（ファイル登録エラー）
            this.$toast.memo(resFile.data.message);
            this.getData(this.corpId, this.managedCorpId);
            this.deleted_0 = this.deleted_1 = this.deleted_2 = false;
            this.detailOpen(this.selectedMemo.memoId);
          }
        }else{
          // エラーメッセージ表示（上記以外のエラー）
          this.$toast.memo('予期せぬエラーが発生しました。');
          await this.getData(this.corpId, this.managedCorpId)
          this.listOpen();
        }
      } else if ( res.status === 500 ) {
        if ( res.data.status === 501 ) {
          // エラーメッセージ表示（入力エラー）
          this.$toast.memo(res.data.message);
        }else if ( res.data.status == 502 ) {
          // エラーメッセージ表示（排他エラー）
          this.$toast.memo(res.data.message);
          await this.getData(this.corpId, this.managedCorpId)
          this.listOpen();
        }else{
          this.$toast.memo('予期せぬエラーが発生しました。');
          await this.getData(this.corpId, this.managedCorpId)
          this.listOpen();
        }
      }else{
          this.$toast.memo('予期せぬエラーが発生しました。');
          await this.getData(this.corpId, this.managedCorpId)
          this.listOpen();
      }
    },
    /**
     * メモ編集画面表示
     */
    async memoEdit(memoId){
      if ( memoId != null ) {
        let res = await this.$axios.post('/ld/api/memo/getSelectedMemo', { memoId: memoId });
        if (res.status==200) {
          this.selectedMemo = res.data.memo;
          this.showId = 'memoEdit';
        // 以下、添付非表示のため一旦コメントアウト
//          this.hasAttachment = true;
          this.noFooter = false;
          this.isShow = true;
        }else{
          this.$toast.memo(res.data.message);
          // データ取得できないのでメモ一覧表示
          // メモ情報の取得
          await this.getData(this.corpId, this.managedCorpId)
          // メモ一覧を表示
          this.listOpen();
        }
      }else{
        this.$toast.memo('パラメータエラー');
      }
    },
    /**
     * メモ詳細画面　
     */    
    async memoDelete() {
      if (confirm("このメモを削除すると、元に戻すことはできません。本当に削除してもよろしいですか？")) {
        // メモ情報を削除する
        let res = await this.$axios.post('/ld/api/memo/deleteMemo', { memoId: this.selectedMemo.memoId });
        if (res.status === 200) {
          this.$toast.memo('メモを削除しました');
          this.getData(this.corpId, this.managedCorpId);

          this.showId = 'memoList';
          this.hasAttachment = false;
          this.noFooter = false;
          this.isShow = true;
        } else {
          this.$toast.memo(res.data.message);
        }
      }
    },
    async histOpen() {
      this.histIsShow = true;
    },
    async histClose() {
      this.histIsShow = false;
    },
    /**
     * メモ編集画面　キャンセル処理
     */
    async editCancel() {
      if ( confirm('編集中の内容は保存されません。このままキャンセルしてもよろしいですか？') ){
        this.deleted_0 = this.deleted_1 = this.deleted_2 = false;
        this.detailOpen(this.selectedMemo.memoId);
      }
    },

    /**
     * メモ登録処理
     */
    async newSave() {
      // メモ情報を保存する
      this.selectedMemo.memoId = null;
      this.selectedMemo.corpId = this.corpId;
      this.selectedMemo.managedCorpId = this.managedCorpId;
      let res = await this.$axios.post('/ld/api/memo/storeMemo', { memo: this.selectedMemo });
      if (res.status === 200) {
        var memoId = res.data.id;
        const formData = new FormData()
        var index = 0;
        this.selectedMemo.attachments.forEach(attachment => {
          formData.append('file['+ index + ']', attachment.data);
          index++;
        });
        formData.append('memoId', memoId);
        //config定義（headersを指定）
        const config = {headers:{ 'Content-Type' : 'multipart/form-data' }}
        let resFile = await this.$axios.post('/ld/api/memo/storeAttachment', formData, config);
        if ( resFile.status == 200 ){
          this.$toast.info('登録が完了しました');

          await this.getData(this.corpId, this.managedCorpId);

          this.detailOpen(memoId);
        }else if (resFile.status === 501) {
          // エラーメッセージ表示
          this.$toast.memo(resFile.data.message);
          this.detailOpen(memoId);
        }else {
          // エラーメッセージ表示
          this.$toast.memo(resFile.data.message);
        }
      } else if (res.status === 500) {
        if ( res.data.status === 501 ) {
          // エラーメッセージ表示(入力)
          this.$toast.memo(res.data.message);
        }else if ( res.data.status === 503 ){
          // エラーメッセージ表示(制限値)
          this.$toast.memo(res.data.message);
          await this.getData(this.corpId, this.managedCorpId)
          this.listOpen();
         }else if ( res.data.status === 500 ){
          // エラーメッセージ表示(予期せぬエラー)
          this.$toast.memo(res.data.message);
        }
      } else {
        // エラーメッセージ表示(予期せぬエラー)
        this.$toast.memo(res.data.message);
      }
    },
    async newCancel() {

      if ( confirm('編集中の内容は保存されません。このままキャンセルしてもよろしいですか？') ){
        this.showId = 'memoList';
        this.hasAttachment = false;
        this.noFooter = false;
        this.isShow = true;
      }
      this.getData(this.corpId, this.managedCorpId);
    },
    initSelectedMemo(nextNum) {
      this.selectedMemo = {
        attachments: [],
        title: "新規メモ"+nextNum,
        body: "",
        showFlg: false,
        shareFlg: false,
        corpId: null,
        managedCorpId: null,
      };
    },
    /**
     * メモ新規登録　表示
     */
    async newOpen() {

      let res = await this.$axios.post('/ld/api/memo/checkMemoCount', {
        corpId: this.corpId,
        managedCorpId: this.managedCorpId,
      });
      if (res.status==200) {
        let nextNum = res.data.num+1;
        this.initSelectedMemo(nextNum);
        this.errorMessage = "";
        this.showId = 'memoNew';
        // 以下、添付非表示のため一旦コメントアウト
//        this.hasAttachment = true;
        this.noFooter = false;
        this.isShow = true;
      }else{
        this.$toast.memo(res.data.message);
      }
    },
    /**
     * to open memo detial.
     */
    async detailOpen(memoId) {
      if ( memoId != null ) {
        let res = await this.$axios.post('/ld/api/memo/getSelectedMemo', { memoId: memoId });
        if (res.status==200) {
          this.selectedMemo = res.data.memo;
          this.errorMessage = "";
          this.showId = 'memoDetail';
          if ( (this.selectedMemo.attachments.length > 0) && (this.selectedMemo.shareFlg || this.selectedMemo.showFlg) ) {
            this.hasAttachment = true;
          }else {
            this.hasAttachment = false;
          }
          this.noFooter = false;
          this.isShow = true;
        }else{
          this.$toast.memo(res.data.message);
          // データ取得できないのでメモ一覧表示
          // メモ情報の取得
          await this.getData(this.corpId, this.managedCorpId)
          // メモ一覧を表示
          this.listOpen();
        }
      }else{
        this.$toast.memo('パラメータエラー');
      }
    },
    async listOpen() {
      await this.getData(this.corpId, this.managedCorpId);      
      this.showId = 'memoList';
      this.hasAttachment = false;
      this.noFooter = false;
    },
    // 文字列中のURLをaタグに変換する
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },
    shareChange: function (memo) {
      if ( memo.shareFlg ) {
          alert("メモを共有すると、顧問先のユーザーもメモの閲覧・編集が可能になります");
      }
      if ( !memo.shareFlg && memo.showFlg ) memo.showFlg = false;
    },
    showChange: function (memo) {
      if ( memo.showFlg && memo.shareFlg ) {
          alert("カルテに表示できるメモは1件です。現在カルテに表示されているメモがある場合、このメモと差し代わります。");
      }else if ( memo.showFlg && !memo.shareFlg ){
          alert("カルテに表示するには共有にチェックをいれてください。");
      }
    }
  },
  updated: async function() {
    let message = this.$store.getters['alert/getMessage'];
    if (message) {
      this.$toast.info(message);
    }
    this.$store.dispatch('alert/setMessage', '');
  },
};
</script>
